<template>
  <van-dialog class-name="member-expired-dialog" :title="null" :show="showDialog" :show-confirm-button="false">
    <div class="user-info-wrap member-expired-ctn">
      <p class="text-danger">会员已到期, 请购买会员或分享给好友</p>
      <van-tabs>
        <van-tab title="购买会员">
          <MemberPay></MemberPay>
        </van-tab>
        <van-tab title="分享好友">
          <p>分享给你的好友, 好友注册之后, 你即可获得3天会员!</p>
          <Clipbord notifyText="复制成功,马上邀请好友"  type="danger" :show-copy-button="true" :show-content="false" btn-text="复制分享链接" :text="shareUrl" />
        </van-tab>
      </van-tabs>
    </div>
  </van-dialog>
</template>
<style>
.member-expired-ctn{
  color: #1c1c1e;
  font-size: var(--van-cell-value-font-size);
}
.member-expired-ctn.user-info-wrap{
  background: #fff;
}
.member-expired-dialog.van-dialog{
  top: 50%;
}
</style>
<script setup>
import MemberPay from "@/views/MemberPay.vue";
import ClipbordComponent from "@/components/Clipbord.vue";
</script>
<script>
import Clipbord from "@/components/Clipbord.vue";
import VueQrcode from "@chenfengyuan/vue-qrcode";

export default {
  name: "ShareNotice",
  components: {Clipbord, VueQrcode},
  props:['showDialog', 'shareUrl'],
  setup() {

  }
}
</script>
